module.exports = __webpack_public_path__ + "static/media/face_overlay.35a206ea.svg";